export default __webpack_public_path__ + "static/media/comets.6178c3bd.svg";